import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { DialogService } from '../../../services/utils/dialog.service';
import { SnackBarService } from '../../../services/utils/snackBar.service';
import { FormBuilder, FormGroup, ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { CommonMetodService } from 'src/app/core/services/utils/commonMetod.service';
import { CurrencyPipe } from '@angular/common';

export interface DialogData {
  title: string
  name: string;
  url?: string;
  comment: string;
  aceptText: string;
  isRechazo: boolean;
  isRetiro: boolean;
  isAccessDates?: boolean;
  startDate?: string;
  finishDate?: string;
}

@Component({
  selector: 'app-dialog-individual-contract-aproved',
  templateUrl: './dialog-individual-contract-aproved.component.html',
  styleUrls: ['./dialog-individual-contract-aproved.component.scss']
})
export class DialogIndividualContractAprovedComponent implements OnInit {
  s3Bucket:string;

  comment: string = ''
  form: FormGroup;
  minToday: string;

  constructor(
    public dialogRef: MatDialogRef<DialogIndividualContractAprovedComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private dialogService: DialogService,
    private currencyPipe: CurrencyPipe,
    private commonMetodService: CommonMetodService,
    private fb: FormBuilder,
  ) {
    this.minToday = this.getTodayForInput();
    const maxDateValidator = this.maxDateValidator(data?.finishDate);
    const minTodayValidator = this.minDateValidator(this.minToday);
    this.form = this.fb.group({
      Severance : 0,
      StartDate: [data?.startDate ?? '', data?.isAccessDates ? [minTodayValidator, maxDateValidator] : []],
      FinishDate: [data?.finishDate ?? '', data?.isAccessDates ? [this.minStartDateValidator(), maxDateValidator] : []],
    });
    this.form.get('StartDate')?.valueChanges.subscribe(() => {
      this.form.get('FinishDate')?.updateValueAndValidity({ emitEvent: false });
    });
    this.form.valueChanges.subscribe(form => {
      if(form.Severance && this.commonMetodService._validarDateMoney(form.Severance)
        ) {
        this.form.patchValue({
          Severance: this.currencyPipe.transform(form.Severance.toString().replace(/\D/g, '').replace(/^0+/, ''), 'USD', 'symbol', '1.0-0').replace(/,/gi, '.')
        }, {emitEvent: false});
      }
    });
   }



  onNoClick(): void {
    this.dialogRef.close();
  }

  show() {
    this.dialogService.openDialogImageOrVideoOrPdf(this.data.url).afterClosed().subscribe(rest =>{
    });
  }

  acept(): void {
    if (this.data.isAccessDates) {
      this.dialogRef.close({
        Comment: this.comment,
        StartDate: this.form.get('StartDate').value,
        FinishDate: this.form.get('FinishDate').value
      });
    } else if(this.data.isRechazo !== undefined && this.data.isRetiro === undefined) {
      // if(this.comment === '') {
      //   this.snackBService.openWarning('Colocar comentario para rechazar la orden', 'X', 4000);
      // } else {
        this.dialogRef.close(this.comment);
      // }
    } else if(this.data.isRechazo !== undefined && this.data.isRetiro !== undefined) {
      this.dialogRef.close({Comment: this.comment, Severance: this.form.get('Severance').value});
    }
     else {
      this.dialogRef.close(true);
    }
  }

  ngOnInit(): void {
    this.s3Bucket= environment.api.s3Bucket;
  }

  private maxDateValidator(maxDate: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!maxDate || !control.value) { return null; }
      return new Date(control.value) > new Date(maxDate) ? { maxDate: true } : null;
    };
  }

  private minDateValidator(minDate: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!minDate || !control.value) { return null; }
      return new Date(control.value) < new Date(minDate) ? { minDate: true } : null;
    };
  }

  private minStartDateValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const startValue = control.parent?.get('StartDate')?.value;
      if (!startValue || !control.value) { return null; }
      return new Date(control.value) < new Date(startValue) ? { minStartDate: true } : null;
    };
  }

  private getTodayForInput(): string {
    const now = new Date();
    const yyyy = now.getFullYear();
    const mm = String(now.getMonth() + 1).padStart(2, '0');
    const dd = String(now.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}T00:00`;
  }

  openPicker(input: HTMLInputElement): void {
    if (typeof (input as any).showPicker === 'function') {
      (input as any).showPicker();
    } else {
      input.focus();
    }
  }


}
